/* NP · rychlý náhled na dotyku
 *
 * Impulse váže rychlý náhled na mouseover a na malém breakpointu ho
 * vypíná úplně ("No quick view on mobile breakpoint"). Na telefonu tedy
 * tlačítko existovalo, ale nic nedělalo: obsah se nikdy nepřednačetl,
 * takže zůstalo v btn--not-ready a theme.Modals se nikdy nevytvořil.
 *
 * Tenhle skript nepřepisuje theme.js. Zachytí první klepnutí, zavolá
 * původní theme.preloadProductModal a jakmile Modals sebere třídu
 * btn--not-ready (dělá to až po dotažení obsahu), klepnutí zopakuje —
 * takže uživateli stačí jeden tap.
 */
(function () {
  function isReady(btn) {
    return !btn.classList.contains('btn--not-ready');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.quick-product__btn') : null;
    if (!btn || isReady(btn)) return;           // hotové tlačítko si obslouží theme
    if (!window.theme || !theme.preloadProductModal) return;

    var card = btn.closest('.grid-product');
    if (!card || !card.dataset.productId || !card.dataset.productHandle) return;
    if (btn.dataset.npLoading) return;          // druhý tap během načítání ignoruj

    e.preventDefault();
    e.stopPropagation();
    btn.dataset.npLoading = '1';
    btn.setAttribute('aria-busy', 'true');

    theme.preloadProductModal(card.dataset.productHandle, card.dataset.productId, btn);

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (isReady(btn)) {
        clearInterval(timer);
        delete btn.dataset.npLoading;
        btn.removeAttribute('aria-busy');
        btn.click();                            // teď už otevře theme
      } else if (tries > 80) {                  // ~8 s, pak to vzdáme
        clearInterval(timer);
        delete btn.dataset.npLoading;
        btn.removeAttribute('aria-busy');
      }
    }, 100);
  }, true);
})();
